import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivityListComponent } from './components/ticket-details-panel/activity-list/activitylist/activity-list.component';
import { ActivityComponent } from './components/ticket-details-panel/activity/activity.component';
import { NoteActivityComponent } from './components/ticket-details-panel/activity/note-activity/note-activity.component';
import { NoteComponent } from './components/ticket-details-panel/activity/note-activity/note/note.component';
import { SnapshotActivityComponent } from './components/ticket-details-panel/activity/snapshot-activity/snapshot-activity.component';
import { SnapshotActivityContentComponent } from './components/ticket-details-panel/activity/snapshot-activity/snapshot-activity-content/snapshot-activity-content.component';
import { RemoteControlActivityComponent } from './components/ticket-details-panel/remote-control-activity/remote-control-activity.component';
import { AttachmentActivityComponent } from './components/ticket-details-panel/attachment-activity/attachment-activity.component';
import { ExistingAttachmentActivityComponent } from './components/ticket-details-panel/attachment-activity/existing-attachment-activity/existing-attachment-activity.component';
import { AttachmentNoteComponent } from './components/ticket-details-panel/attachment-activity/attachment-note/attachment-note.component';
import { DeviceCaptureActivityComponent } from './components/ticket-details-panel/device-capture-activity/device-capture-activity.component';
import { OutboundEmailActivityComponent } from './components/ticket-details-panel/outbound-email/outbound-email-activity.component';
import { InboundEmailActivityComponent } from './components/ticket-details-panel/inbound-email-activity/inbound-email-activity.component';
import { EmailAttachmentListComponent } from './components/ticket-details-panel/email-attachment-list/email-attachment-list.component';
import { AttachmentMenuComponent } from 'xsmodules/ticket/components/ticket-details-panel/outbound-email/attachment-menu/attachment-menu.component';
import { RecipientsListComponent } from './components/ticket-details-panel/outbound-email/recipients-list/recipients-list.component';
import { CollapsibleUserListComponent } from './components/ticket-details-panel/collapsible-user-list/collapsible-user-list.component';
import { AutoSizeFrameDirective } from './components/ticket-details-panel/auto-size-frame.directive';
import { FileSizeFormatPipe, PipesModule, SaI18nPipe, XsI18nPipe } from '@nx-fe/pipes';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { PopupModule } from '@soti/popup';
import { SelectModule } from '@soti/select';
import { TicketPageService } from './ticket-page.service';
import { AttachmentService } from './services/attachment.service';
import { XSightRestClientService } from 'app/services/xs-rest-client.service';
import { XSi18nService } from '../../../../../../libs/services/xsi18n.service';
import { EmailActivityService } from './services/email.service';
import { MatSelectToolTipVisiblePipe } from 'app/shared/pipes/sa-matselecttooltipvisible.pipe';
import { ShortDateFormatPipe } from 'app/shared/pipes/time-format.pipe';
import { DeviceIconService } from './services/device-icon.service';
import { DeviceContextService } from '../../../../../../libs/services/device-context.service';
import { UploadService } from '../../../../../../libs/services/upload.service';
import { RemoteControlModule } from '../remote-control/remote-control.module';
import { WorkPanelModule } from './components/work-panel/work-panel.module';
import { SharedComponentsModule } from 'app/shared/shared-components.module';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDividerModule } from '@angular/material/divider';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedDialogsModule } from '../../../../../../libs/shared-dialogs/src/lib/shared-dialogs.module';
import { MatMenuModule } from '@angular/material/menu';
import { SvgIconsModule } from '../../../../../../libs/icons/src/lib/svg-icons.module';
import { QuillModule } from 'ngx-quill';
import { TooltipModule } from '@soti/tooltip';
import { SharedDirectivesModule } from '../../../../../../libs/shared-directives/src/lib/shared-directives.module';
import { LocalAttachmentActivityComponent } from './components/ticket-details-panel/attachment-activity/local-attachment-activity/local-attachment-activity.component';

@NgModule({
  declarations: [
    ActivityListComponent,
    ActivityComponent,
    NoteActivityComponent,
    NoteComponent,
    SnapshotActivityComponent,
    SnapshotActivityContentComponent,
    RemoteControlActivityComponent,
    AttachmentActivityComponent,
    ExistingAttachmentActivityComponent,
    AttachmentNoteComponent,
    DeviceCaptureActivityComponent,
    OutboundEmailActivityComponent,
    InboundEmailActivityComponent,
    EmailAttachmentListComponent,
    AttachmentMenuComponent,
    RecipientsListComponent,
    CollapsibleUserListComponent,
    AutoSizeFrameDirective,
    LocalAttachmentActivityComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatTabsModule,
    MatRadioModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatSelectModule,
    MatDialogModule,
    MatDividerModule,
    MatProgressBarModule,
    RouterModule,
    PipesModule,
    SharedDialogsModule,
    WorkPanelModule,
    SharedComponentsModule,
    SelectModule,
    PopupModule,
    MatAutocompleteModule,
    MatInputModule,
    MatFormFieldModule,
    MatMenuModule,
    SvgIconsModule,
    QuillModule.forRoot(),
    TooltipModule,
    SharedDirectivesModule,
    RemoteControlModule,
  ],
  providers: [
    TicketPageService,
    AttachmentService,
    XSightRestClientService,
    XSi18nService,
    EmailActivityService,
    MatSelectToolTipVisiblePipe,
    FileSizeFormatPipe,
    ShortDateFormatPipe,
    DeviceIconService,
    DeviceContextService,
    UploadService,
    XsI18nPipe,
    SaI18nPipe,
  ],
  schemas: [NO_ERRORS_SCHEMA],
  exports: [
    ActivityListComponent,
    ActivityComponent,
    NoteActivityComponent,
    NoteComponent,
    SnapshotActivityComponent,
    SnapshotActivityContentComponent,
    RemoteControlActivityComponent,
    AttachmentActivityComponent,
    ExistingAttachmentActivityComponent,
    AttachmentNoteComponent,
    DeviceCaptureActivityComponent,
    OutboundEmailActivityComponent,
    InboundEmailActivityComponent,
    EmailAttachmentListComponent,
    AttachmentMenuComponent,
    RecipientsListComponent,
    CollapsibleUserListComponent,
    AutoSizeFrameDirective,
    FormsModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatTooltipModule,
    MatSelectModule,
    RouterModule,
    PipesModule,
    SelectModule,
    PopupModule,
    MatAutocompleteModule,
    MatInputModule,
    MatFormFieldModule,
    RemoteControlModule,
    WorkPanelModule,
  ],
})
export class SharedTicketModule {}
